import { FatSeekingInterestPageInvestmentQuery } from '@/__generated__/graphql';
import { EditIcon } from '@/assets/icons/edit';
import { IInfoIcon } from '@/assets/icons/info-icons/i-info';
import CheckBox from '@/components/basicComponents/checkbox';
import { Tooltip } from '@/components/basicComponents/tooltip';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import Suitability from '@/components/investors-page/investorDetailsPage/tabs/beginAllocationTab/table/suitability';
import ClientsAdvisor from '@/components/pendingCommitments-page/table/cell/clientsAdvisor';
import { AnchorPopover } from '@/components/table/anchor-drop-down';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import guid from '@/shared/utils/guid';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import SuitabilityDetails, { SuitabilityWrapper } from '../../allocator-page/table/cell/suitabilityDetails';
import { columns } from '../constants';
import { IInvestmentEntity } from '../types';

interface OpenOpportunitiesTableBodyProps {
  listInvestmentEntity: IInvestmentEntity[];
  investment: FatSeekingInterestPageInvestmentQuery['Investment'] | null;
  openModalWindow: (type: string, row: IInvestmentEntity) => void;
  selectRow: (row: any) => void;
  openInvestorDetailsPage: ({ investorId, entityId, isGroup }: { investorId: string; entityId?: string; isGroup?: boolean }) => Promise<void>;
}

const TableBody = ({ listInvestmentEntity, investment, openModalWindow, selectRow, openInvestorDetailsPage }: OpenOpportunitiesTableBodyProps) => {
  if (!listInvestmentEntity?.length) {
    return <NoResults />;
  }

  return (
    <>
      {listInvestmentEntity.map((row) => (
        <TableRowWrapper key={row.id}>
          <TableRowCell>
            <CheckboxWrapper id={'input'} onClick={() => selectRow(row)}>
              <CheckBox id={'input'} isActive={row.checked} />
            </CheckboxWrapper>
          </TableRowCell>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell
              id="actionCurioText"
              onClick={() => openInvestorDetailsPage({ investorId: row?.family.id, entityId: row.id, isGroup: !!row.groupId })}
            >
              {row?.entityName}
            </RedirectTitleCell>
            {/* <Entity
              row={row}
              onRedirect={() => openEntityDetails(row.family.id, row.id)}
              hyperTitle={() => openEntityDetails(row.family.id, row.id)}
              investment={investment}
            /> */}
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <ClientsAdvisor
              onRedirect={() => openInvestorDetailsPage({ investorId: row?.family.id })}
              familyName={row?.family.name}
              advisor={row?.advisor ? row?.advisor?.initials || `${row?.advisor?.firstName} ${row?.advisor?.lastName}` : null}
            />
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000}>{row.overallCapacity}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000}>{row.assetClassCapacity}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <AnchorPopover
              zIndex={9999}
              showLeft
              rowBody={
                <SuitabilityWrapper>
                  <Suitability suitability={row.suitability === 'Suitable' ? 'Meets Criteria' : row.suitability} width="80" />
                  {row.ignoreBiteSize ||
                    (((investment?.type === 'Restricted Alternative' && row.investor_interest[0]?.amount !== row.directBiteSize) ||
                      (investment?.type === 'Illiquid Alternative' && row.investor_interest[0]?.amount !== row.fundBiteSize)) && (
                      <Tooltip title="Differs from default bite size">
                        <IInfoIcon fill={themeVar('context.warning')} />
                      </Tooltip>
                    ))}
                </SuitabilityWrapper>
              }
              title={row.suitability === 'Suitable' ? 'Meets Criteria' : row.suitability}
            >
              <SuitabilityDetails data={row?.suitabilityCriteria || []} key={guid()} />
            </AnchorPopover>
          </TableRowCell>
          <TableRowCell width={columns[5].width}>
            <TextCell>
              <AmountWrapper onClick={() => openModalWindow('edit-amount', row)}>
                <RedirectTitleCell>
                  <FormattingTooltip zIndex={1000}>{row.investor_interest[0]?.amount}</FormattingTooltip>
                </RedirectTitleCell>
                <EditIconWrap id="infoWrap">
                  <EditIcon style={{ cursor: 'pointer' }} fill={themeVar('font.action')} width={23} height={23} />
                </EditIconWrap>
              </AmountWrapper>
            </TextCell>
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const CheckboxWrapper = styled.div`
  margin-right: 15px;
`;

const AmountWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const EditIconWrap = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
`;
